module.exports = __webpack_public_path__ + "img/Z61Q_07.0ae6c2fe.jpg";